import { find as _find } from 'lodash';
import { without as _without } from 'lodash';

class FinancialProductContainerController {
  constructor(authService, enums, $stateParams, lookupService, loadingService, financialProductManagementService, addEditFinancialProductService) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.lookupService = lookupService;
    this.loadingService = loadingService;
    this.financialProductManagementService = financialProductManagementService;
    this.addEditFinancialProductService = addEditFinancialProductService;

    this.financialProductLookups = [];
    this.initializeFinancialProducts();

    this.state = '';
    this.resetNotification();
  }

  resetNotification() {
    this.notification = {
      type: '',
      msg: ''
    };
  }

  initializeFinancialProducts() {
    const ctrl = this;

    ctrl.loadingService.showLoading('financialProductList', 'Loading Products ...');

    ctrl.lookupService.lookupEnquiryPrices(ctrl.$stateParams.locationId)
      .then(data => {
        ctrl.financialProductLookups = data.financialProducts;
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('financialProductList');
      });
  }

  removeFinancialProduct(financialProduct) {
    const ctrl = this;

    ctrl.loadingService.showLoading('financialProductList', 'Removing Product ...');

    ctrl.financialProductManagementService.removeFinancialProduct(ctrl.$stateParams.locationId, financialProduct.financialProductId)
      .finally(() => {
        ctrl.initializeFinancialProducts();
        ctrl.loadingService.hideLoading('financialProductList');
      });
  }

  showAdd() {
    this.addEditFinancialProductService.showAdd(this.financialProductLookups, this.addFinancialProduct.bind(this));
  }

  showEdit(financialProduct) {
    this.addEditFinancialProductService.showEdit(this.financialProductLookups, financialProduct);
  }

  addFinancialProduct(newItem) {
    this.financialProductLookups.push(newItem);
  }
}

export default FinancialProductContainerController;



// WEBPACK FOOTER //
// ./client/app/components/admin/financialProductManagement/financialProductContainer/financialProductContainer.controller.js